// useTriggerRefresh — useMutation wrapper for POST /api/admin/refresh.
// On success invalidates ['admin-amenities'] so the matrix re-fetches and
// the UI reflects the new running status. ConcurrencyError (409) bubbles
// as ApiError for the caller to render an inline banner.

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { triggerRefresh } from '@/lib/api';
import type { AdminRefreshScope, AdminRefreshResponse } from '@/types/db';

export function useTriggerRefresh(): UseMutationResult<
  AdminRefreshResponse,
  Error,
  AdminRefreshScope
> {
  const qc = useQueryClient();
  return useMutation<AdminRefreshResponse, Error, AdminRefreshScope>({
    mutationFn: (payload) => triggerRefresh(payload),
    retry: false,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin-amenities'] });
    },
  });
}
